import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";

const ChartTax = (props) => {
  const { Tax, JanValue, year } = props;

  const [chartData, setChartData] = useState({
    options: {
      chart: {
        height: 328,
        type: "line",
        zoom: {
          enabled: false,
        },
      },
      stroke: {
        curve: "smooth",
        width: 2,
      },
      series: [],
      title: {
        text: "บริษัทนำส่งรวม",
        align: "left",
        offsetY: 25,
        offsetX: 20,
      },
      subtitle: {
        text: "Statistics",
        offsetY: 55,
        offsetX: 20,
      },
      markers: {
        size: 6,
        strokeWidth: 0,
        hover: {
          size: 9,
        },
      },
      grid: {
        show: true,
        padding: {
          bottom: 0,
        },
      },
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      xaxis: {
        tooltip: {
          enabled: false,
        },
      },
      legend: {
        position: "top",
        horizontalAlign: "right",
        offsetY: -20,
      },
    },
  });

  useEffect(() => {
    const newSeries = [
      {
        name: "ภาษีนำส่ง",
        data: year < 2024
          ? [{ month: "01", value: JanValue }, ...Tax].map(i => i.value)
          : Object.values(Tax).map(i => i.value),
      },
    ];
  
    setChartData(prevState => ({
      ...prevState,
      options: {
        ...prevState.options,
        series: newSeries,
      },
    }));
  }, [Tax, JanValue]);

  return (
    <div className="app">
      <div className="row">
        <div className="mixed-chart">
          <Chart
            options={chartData.options}
            series={chartData.options.series}
            type="line"
            width="100%"
          />
        </div>
      </div>
    </div>
  );
};

export default ChartTax;
